export enum EtapasAuth {
    PhoneNumber,
    SMSCode,
    Cpf,
    Username,
    NewUser
}
